import React from "react";
import Radio from "../../../../../shared/Radio/Radio";
import { STATUS } from "../../consts";

const StatusRadioSelector = props => {
	const handleChange = event => {
		props.onChange({ status: event.value });
	};

	return (
		<div>
			<h5>Escolha o status</h5>
			<Radio
				className="filter-type-sale"
				onChange={handleChange}
				options={[
					{
						label: "TODOS",
						value: STATUS.ALL,
						checked: props.status === STATUS.ALL
					},
					{
						label: "A RECEBER",
						value: STATUS.TO_BE_RECEIVED,
						checked: props.status === STATUS.TO_BE_RECEIVED
					},
					{
						label: "RECEBIDO",
						value: STATUS.RECEIVED,
						checked: props.status === STATUS.RECEIVED
					},
					{
						label: "CANCELADO",
						value: STATUS.CANCELED,
						checked: props.status === STATUS.CANCELED
					},
					{
						label: "SUSPENSO",
						value: STATUS.SUSPENDED,
						checked: props.status === STATUS.SUSPENDED
					},
					{
						label: "REVENDA",
						value: STATUS.RESALE,
						checked: props.status === STATUS.RESALE
					},
					{
						label: "PAGAMENTOS CONGELADOS",
						value: STATUS.FROZEN_PAYMENT,
						checked: props.status === STATUS.FROZEN_PAYMENT
					}
				]}
				data-action="status-radio-selector-filter-type-sale-radio"
			/>
		</div>
	);
};

export default StatusRadioSelector;
